import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    data: null,
    message: null,
    error: null,
    successStatus: null,
    reload: null,
    createStatus: null,
    updateStatus: null,
    deleteStatus: null,
    deleteTransferStatus: null,
    salesPlanData: null,
    salesPlanMainData: null, 
}

const salesPlanSlice = createSlice({
    name: 'salesPlan',
    initialState,
    reducers: {

        getMainSalesPlanStart: (state) => {
            state.isLoading = true;
            state.data = null;
            state.error = null;
        },
        getMainSalesPlanSuccess: (state, action) => {
            // state.data = action?.payload?.salesPlan;
            state.salesPlanMainData = action?.payload;
            state.isLoading = false;
        },
        getMainSalesPlanFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        createMainSalesPlanStart: (state, action) => {
            state.isLoading = true;
            state.createStatus = null;
        },
        createMainSalesPlanSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
            state.data = action?.payload?.savedMainSalesPlan; 
            state.payload = action?.payload;
        },
        createMainSalesPlanFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
        },
        updateMainSalesPlanStart: (state, action) => {
            state.isLoading = true;
            state.updateStatus = null;
        },
        updateMainSalesPlanSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateStatus = action?.payload?.success;
        },
        updateMainSalesPlanFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateStatus = action?.payload?.success;
        },
        deleteMainSalesPlanStart: (state, action) => {
            state.isLoading = true;
            state.deleteStatus = null;
        },
        deleteMainSalesPlanSuccess: (state, action) => {
            state.isLoading = false;
            state.deleteStatus = action?.payload?.success;
        },
        deleteMainSalesPlanFailure: (state, action) => {
            state.isLoading = false;
            state.deleteStatus = action?.payload?.success;
        },
        setMainSalesPlanData: (state, action) => {
            state.salesPlanData = action?.payload;
        },
        clearMainSalesPlanData: (state) => {
            state.salesPlanData = null;
        },
        getSalesPlanStart: (state) => {
            state.isLoading = true;
            state.data = null;
            state.error = null;
        },
        getSalesPlanSuccess: (state, action) => {
            // state.data = action?.payload?.salesPlan;
            state.salesPlanData = action?.payload?.salesPlan;
            console.log("Sales Plan Data:", action?.payload?.salesPlan);
            console.log("salesPlanData", )
            state.isLoading = false;
            state.deleteStatus = null; 
            state.createStatus = null;
            state.updateStatus = null; 
            state.deleteStatus = null; 
        },

        getSalesPlanFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        createSalesPlanStart: (state, action) => {
            state.isLoading = true;
            state.createStatus = null;
        },
        createSalesPlanSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
        },
        createSalesPlanFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
        },
        updateSalesPlanStart: (state, action) => {
            state.isLoading = true;
            state.updateStatus = null;
        },
        updateSalesPlanSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateStatus = action?.payload?.success;
        },
        updateSalesPlanFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateStatus = action?.payload?.success;
        },
        deleteSalesPlanStart: (state, action) => {
            state.isLoading = true;
            state.deleteStatus = null;
        },
        deleteSalesPlanSuccess: (state, action) => {
            state.isLoading = false;
            state.deleteStatus = action?.payload?.success;
        },
        deleteSalesPlanFailure: (state, action) => {
            state.isLoading = false;
            state.deleteStatus = action?.payload?.success;
        },
        setReload: (state, action) => {
            state.reload = action?.payload;
        },
        setSalesPlanData: (state, action) => {
            state.salesPlanData = action?.payload;
        },
        clearSalesPlanData: (state) => {
            state.salesPlanData = null;
        },

        


    }
});

export const {
    getMainSalesPlanStart,
    getMainSalesPlanSuccess,
    getMainSalesPlanFailure,
    createMainSalesPlanStart,
    createMainSalesPlanSuccess,
    createMainSalesPlanFailure,
    updateMainSalesPlanStart,
    updateMainSalesPlanSuccess,
    updateMainSalesPlanFailure,
    deleteMainSalesPlanStart,
    deleteMainSalesPlanSuccess,
    deleteMainSalesPlanFailure,
    getSalesPlanStart,
    getSalesPlanSuccess,
    getSalesPlanFailure,
    createSalesPlanStart,
    createSalesPlanSuccess,
    createSalesPlanFailure,
    updateSalesPlanStart,
    updateSalesPlanSuccess,
    updateSalesPlanFailure,
    deleteSalesPlanStart,
    deleteSalesPlanSuccess,
    deleteSalesPlanFailure,
    setReload,
    setSalesPlanData,
    clearSalesPlanData
} = salesPlanSlice.actions;

export default salesPlanSlice?.reducer;